<template>
  <div class="outer">
    <div class="monitor">
      <div class="image-strings" :class="[isStrings ? 'show':' hide']" >Strings image</div>
      <div class="image-brass" :class="[isBrass ? 'show':' hide']" >Brass image</div>
      <div class="image-woodwinds" :class="[isWoodwinds ? 'show':' hide']">woodwinds image</div> 
      <div class="image-percussion" :class="[isPercussion ? 'show':' hide']">Percussion image</div> -->
      <div class="image-all" :class="[isAll ? 'show':' hide']" >All image</div>
    </div>

    <div class="console">

        <a href="#"
        class="console-button strings" :class="[isStrings ? 'show':' hide']"
        @click="orchestraHighlight('strings'), toggleAudioByName('classicalStrings')"
        >Strings</a>

        <a href="#"
        class="console-button brass" :class="[isBrass ? 'show':' hide']"
        @click="orchestraHighlight('brass'), toggleAudioByName('classicalBrass')" 
        >Brass</a>

        <a href="#"
        class="console-button woodwinds" :class="[isWoodwinds ? 'show':' hide']"
        @click="orchestraHighlight('woodwinds'), toggleAudioByName('classicalWoodwinds')" 
        >Woodwinds</a>

        <a href="#"
        class="console-button percussion" :class="[isPercussion ? 'show':' hide']"
        @click="orchestraHighlight('percussion'), toggleAudioByName('classicalPercussion')"
        >Percussion</a>
        
        <a href="#"
        class="console-button all" :class="[isAll ? 'show':' hide']"
        @click="orchestraHighlight('all'), toggleAudioByName('classicalAll')" 
        >All</a>

        <p class="console-text">Listen to one <br>section<br>at a time.</p>
     </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'Orchestra',
  data: function () {
    return {
      isStrings: false,
      isBrass: false,
      isWoodwinds: false,
      isPercussion: false,
      isAll: false,
    }
  },
  computed: {
    ...mapState([
    ])
  },
  methods: {
    toggleStrings: function(){
      this.isStrings = true
      this.isBrass = false
      this.isWoodwinds = false
      this.isPercussion = false
      this.isAll = false
    },
     toggleBrass: function(){
      this.isStrings = false
      this.isBrass = true
      this.isWoodwinds = false
      this.isPercussion = false
      this.isAll = false
    },
    toggleWoodwinds: function(){
      this.isStrings = false
      this.isBrass = false
      this.isWoodwinds = true
      this.isPercussion = false
      this.isAll = false
    },
    togglePercussion: function(){
      this.isStrings = false
      this.isBrass = false
      this.isWoodwinds = false
      this.isPercussion = true
      this.isAll = false
    },
    toggleAll: function(){
       this.isStrings = false
      this.isBrass = false
      this.isWoodwinds = false
      this.isPercussion = false
      this.isAll = true
    },
    
    ...mapActions([
        "playAudioClassical",
        "toggleAudioByName",
        "toggleMute",
        "toggleThePercussion",
    ]),
    
    
    orchestraHighlight(direction) {
      if (direction === "strings") {
        this.toggleStrings();
      } else if (direction === "brass") {
        this.toggleBrass();
      } else if (direction === "woodwinds") {
        this.toggleWoodwinds();
      } else if (direction === "percussion") {
        this.togglePercussion();
      } else if (direction === "all") {
         this.toggleAll();
      } 
    }
  },
}
</script>

<style lang="scss" scoped>
</style>